import { msalInstance, getApiToken, getGraphToken } from "../authConfig";
import http from "./http";

// 🔹 Utility: check if JWT expired
const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const now = Math.floor(Date.now() / 1000);
    return payload.exp < now;
  } catch {
    return true;
  }
};

// 🔹 Sign in
export const signIn = async () => {
  try {
    const response = await msalInstance.loginPopup({
      scopes: ["openid", "profile", "email"],
    });

    if (response?.account) {
      msalInstance.setActiveAccount(response.account);
      const token = await getApiToken();
      return { token, success: true };
    }
  } catch (error) {
    console.error("MSAL login error:", error);
    return { success: false };
  }
};

// 🔹 Get access token (checks expiry & refreshes automatically)
export const getAccessToken = async () => {
  const cachedToken = localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken");

  if (cachedToken && !isTokenExpired(cachedToken)) {
    return cachedToken; // ✅ Still valid
  }

  // Otherwise get a new token
  const newToken = await getApiToken();
  if (newToken) {
    localStorage.setItem("accessToken", newToken);
  }
  return newToken;
};

// 🔹 Fetch user role
export const getRole = async () => {
  try {
    const token = await getAccessToken();
    if (!token) return null;

    const role = await http.get("/Users/role", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return role;
  } catch (rolesError) {
    console.error("Roles API error:", rolesError);
    return null;
  }
};

// 🔹 Fetch AAD user photo
export const getUserPhoto = async () => {
  try {
    const token = await getGraphToken();
    if (!token) return null;

    const response = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!response.ok) {
      console.warn("Failed to fetch profile photo");
      return null;
    }

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Error getting user photo:", error);
    return null;
  }
};
